<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-between">
      <div class="info-filter">
        <span v-if="controlPacksFilter.period.enabled">
          {{ $t("common.filter.info.periodWith") }}
          {{ controlPacksFilter.period.dateBegin }}
          {{ $t("common.filter.info.periodTo") }}
          {{ controlPacksFilter.period.dateEnd }}
        </span>
        <span v-if="controlPacksFilter.organization.enabled"
          >{{ $t("common.filter.info.organization") }} -
          {{ organizationName }}</span
        >
        <span v-if="controlPacksFilter.payment.enabled"
          >{{ $t("common.filter.info.payment") }} - {{ paymentName }}</span
        >
        <span v-if="controlPacksFilter.sum.enabled">
          {{ $t("common.filter.info.sumMin") }}
          {{ controlPacksFilter.sum.sumBegin }}
          {{ params.goptions.monetary_unit }},
          {{ $t("common.filter.info.sumMax") }}
          {{ controlPacksFilter.sum.sumEnd }}
          {{ params.goptions.monetary_unit }}
        </span>
        <span v-if="controlPacksFilter.status.enabled"
          >{{ $t("common.filter.info.statusPack") }} -
          {{ statusPackName }}</span
        >
        <span v-if="controlPacksFilter.operator.enabled"
          >{{ $t("common.filter.info.operator") }} - {{ operatorName }}</span
        >
      </div>
      <el-button
        :type="filterType"
        size="small"
        @click="filterModal = true"
        v-shortkey="{ F7: ['f7'] }"
        @shortkey.native="onShortKeyRouter"
        ><span class="key-name">F7</span
        >{{ $t("common.buttons.filter") }}</el-button
      >
    </el-row>

    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-full">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          rowSelection="single"
          :columnDefs="controlPacksColumnDefs"
          :rowData="controlPacks"
          :defaultColDef="defaultColDef"
          :gridOptions="controlPacksGridOptions"
          :getRowStyle="getRowStyle"
          :pinnedBottomRowData="controlPacksPinnedBottomRowData"
          :modules="agGridModules"
          @grid-ready="onControlPacksGridReady"
          @first-data-rendered="onControlPacksFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @modelUpdated="onControlPacksModelUpdated"
          @rowSelected="onControlPacksRowSelected"
          @cellContextMenu="onControlPacksRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="24">
        <el-button
          type="primary"
          size="small"
          @click="onEditBtn"
          :disabled="editBtnDisabled"
          v-shortkey="{ Enter: ['enter'], F4: ['f4'], Star: ['*'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F4</span
          >{{ $t("common.buttons.edit") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="onDeleteBtn"
          :disabled="deleteBtnDisabled"
          v-shortkey="{ Del: ['del'], Minus: ['-'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">Del</span
          >{{ $t("common.buttons.delete") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="onReceiptsBtn"
          :disabled="receiptsBtnDisabled"
          v-shortkey="{ F9: ['f9'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F9</span
          >{{ $t("common.buttons.receipts") }}</el-button
        >
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('common.filter.modal.title')"
      :visible.sync="filterModal"
      :close-on-click-modal="false"
      @open="filterModalShow"
      @close="filterModalHide"
      :width="dialogWidth"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="filterForm" :rules="filterRules" ref="filterForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="filterForm.dateEnabled"
                disabled
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.dateRange.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">с</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="dateRange">
              <el-date-picker
                v-model="filterForm.dateRange"
                type="daterange"
                :start-placeholder="$t('common.filter.form.dateRange.start')"
                :end-placeholder="$t('common.filter.form.dateRange.end')"
                :range-separator="$t('common.filter.form.dateRange.separator')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                unlink-panels
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="filterForm.organizationEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.organization.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="organizationCode">
              <el-select
                v-model="filterForm.organizationCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.organizationEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gfirme.data"
                  :key="item.codefirme"
                  :label="item.namefirme"
                  :value="item.codefirme"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.paymentEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.payment.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="paymentCode">
              <el-select
                v-model="filterForm.paymentCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.paymentEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gkindpay.data"
                  :key="item.kindpay"
                  :label="item.kindname"
                  :value="item.kindpay"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.sumEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.sumRange.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.sumRange.from") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="sumRange">
              <currency-input
                placeholder="0.00"
                v-model.lazy="filterForm.sumBegin"
                :disabled="!filterForm.sumEnabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: !filterForm.sumEnabled }"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.sumRange.to") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <currency-input
                placeholder="0.00"
                v-model.lazy="filterForm.sumEnd"
                :disabled="!filterForm.sumEnabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: !filterForm.sumEnabled }"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.statusEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.statusPack.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="statusCode">
              <el-select
                v-model="filterForm.statusCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.statusEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in filterStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.operatorEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.operator.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="operatorCode">
              <el-select
                v-model="filterForm.operatorCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.operatorEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gusers.data"
                  :key="item.userid"
                  :label="item.fio"
                  :value="item.userid"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="filterModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="filterModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col></el-row
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('controlpacks.storn.modal.title')"
      :visible.sync="stornModal"
      :close-on-click-modal="false"
      @open="stornModalShow"
      @close="stornModalHide"
      :width="dialogWidth"
      v-draggable
    >
      <el-form :model="stornForm" :rules="stornRules" ref="stornForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-card shadow="never">
              <div slot="header">
                <span class="card-font-header">{{
                  $t("controlpacks.storn.card.selectTypeStornPack")
                }}</span>
              </div>
              <el-row type="flex" justify="space-between">
                <el-col :span="24">
                  <el-radio-group v-model="stornForm.typeStornId">
                    <el-radio
                      class="radio-vertical-block"
                      :label="0"
                      style="margin-bottom: 10px;"
                      >{{
                        $t("controlpacks.storn.form.typeStornId.onlyBreakLink")
                      }}</el-radio
                    >
                    <el-radio class="radio-vertical-block" :label="1">{{
                      $t("controlpacks.storn.form.typeStornId.stornPack")
                    }}</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
            </el-card>
            <el-card
              shadow="never"
              v-if="stornForm.typeStornId === 0"
              style="margin-top: 10px;"
            >
              <div slot="header">
                <span class="card-font-header">{{
                  $t("controlpacks.storn.card.chooseReason")
                }}</span>
              </div>
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="stornForm.reasonStornIdCode"
                    @blur="onChangeReasonStornIdCode"
                    @keyup.enter.native="onChangeReasonStornIdCode"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                  />
                </el-col>
                <el-col :span="22">
                  <el-form-item prop="reasonStornId">
                    <el-select
                      v-model="stornForm.reasonStornId"
                      :placeholder="$t('common.components.select.placeholder')"
                      clearable
                      filterable
                      style="width: 100%;"
                      size="small"
                    >
                      <el-option
                        v-for="item in stornReasons"
                        :key="item.codereason"
                        :label="item.namereason"
                        :value="item.codereason"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="stornModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="stornModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col></el-row
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="titleEditModal"
      :visible.sync="editModal"
      :close-on-click-modal="false"
      @open="editModalShow"
      @close="editModalHide"
      :width="largeDialogWidth"
      top="1em"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="editForm" :rules="editRules" ref="editForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              :label="$t('controlpacks.edit.form.packnumber.title')"
              label-width="180px"
            >
              <el-input
                v-model="editForm.packnumber"
                clearable
                style="width: 90%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              :label="$t('controlpacks.edit.form.datebank.title')"
              label-width="160px"
            >
              <el-date-picker
                v-model="editForm.datebank"
                :disabled="editFieldDisabled"
                type="date"
                :placeholder="$t('common.components.datePicker.placeholder')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="pickerOptions"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              :label="$t('controlpacks.edit.form.codefirme.title')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="4">
                  <el-input
                    v-model="editForm.mfo"
                    clearable
                    style="width: 100%;"
                    @input="onChangeMfo"
                    :disabled="editFieldDisabled"
                  ></el-input>
                </el-col>
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.codefirmeCode"
                    @blur="onChangeCodefirmeCode"
                    @keyup.enter.native="onChangeCodefirmeCode"
                    :precision="0"
                    :disabled="editFieldDisabled"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>
                <el-col :span="18">
                  <el-select
                    v-model="editForm.codefirme"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in editForm.senders"
                      :key="item.codefirme"
                      :label="item.namefirme"
                      :value="item.codefirme"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="accountSender"
              :label="$t('controlpacks.edit.form.accountSender.title')"
              label-width="180px"
            >
              <el-input
                v-model="editForm.accountSender"
                style="width: 100%;"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="kindpay"
              :label="$t('controlpacks.edit.form.kindpay.title')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.kindpayCode"
                    @blur="onChangeKindpayCode"
                    @keyup.enter.native="onChangeKindpayCode"
                    :precision="0"
                    :disabled="editFieldDisabled"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>

                <el-col :span="22">
                  <el-select
                    v-model="editForm.kindpay"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in editForm.payments"
                      :key="item.kindpay"
                      :label="item.kindname"
                      :value="item.kindpay"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              prop="quantity"
              :label="labelQuantity"
              label-width="180px"
            >
              <el-input-number
                v-model.lazy="editForm.quantity"
                :disabled="editFieldDisabled"
                controls-position="right"
                :min="1"
                :max="65535"
                style="width: 90%;"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              prop="countband"
              :label="labelCountband"
              label-width="180px"
            >
              <el-input-number
                v-model.lazy="editForm.countband"
                :disabled="editFieldDisabled"
                controls-position="right"
                :min="1"
                :max="65535"
                style="width: 90%;"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              prop="summa"
              :label="$t('controlpacks.edit.form.summa.title')"
              label-width="180px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="editForm.summa"
                :disabled="editFieldDisabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: editFieldDisabled }"
                style="width: 90%; height: 36px; line-height: 36px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              v-if="visibleSumprof"
              :label="$t('controlpacks.edit.form.sumprof.title')"
              label-width="180px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="editForm.sumprof"
                class="el-input--small el-input__inner"
                style="width: 90%; height: 36px; line-height: 36px"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="visibleOperator" type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="userid"
              :label="$t('controlpacks.edit.form.userid.title')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.useridCode"
                    @blur="onChangeUseridCode"
                    @keyup.enter.native="onChangeUseridCode"
                    :precision="0"
                    :disabled="editFieldDisabled"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>

                <el-col :span="22">
                  <el-select
                    v-model="editForm.userid"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in params.guserspackedit.data"
                      :key="item.userid"
                      :label="item.fio"
                      :value="item.userid"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="editModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="editModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('controlpacks.receipts.modal.title')"
      :visible.sync="receiptsModal"
      :close-on-click-modal="false"
      @open="receiptsModalShow"
      @close="receiptsModalHide"
      fullscreen
    >
      <el-form :model="receiptsForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="7">
            <el-form-item
              :label="$t('controlpacks.receipts.form.summa.title')"
              label-width="120px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="receiptsForm.summa"
                :disabled="true"
                class="el-input--small el-input__inner moneydisable"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="$t('controlpacks.receipts.form.datebank.title')"
              label-width="120px"
            >
              <el-date-picker
                v-model="receiptsForm.datebank"
                type="date"
                :placeholder="$t('common.components.datePicker.placeholder')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="pickerOptions"
                size="small"
                style="width: 100%"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10"></el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="7">
            <el-form-item
              :label="$t('controlpacks.receipts.form.quantity.title')"
              label-width="120px"
            >
              <el-input
                v-model="receiptsForm.quantity"
                style="width: 100%;"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="$t('controlpacks.receipts.form.countband.title')"
              label-width="120px"
            >
              <el-input
                v-model="receiptsForm.countband"
                style="width: 100%;"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              v-if="receiptsForm.reasonname"
              :label="$t('controlpacks.receipts.form.reasonname.title')"
              label-width="140px"
            >
              <el-input
                v-model="receiptsForm.reasonname"
                style="width: 100%;"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="6" class="grid-container-modalinfopacks">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="packsCountbandColumnDefs"
              :rowData="packsCountband"
              :defaultColDef="defaultColDef"
              :gridOptions="packsCountbandGridOptions"
              :modules="agGridModules"
              :getRowStyle="getRowStyle"
              :pinnedBottomRowData="packsCountbandPinnedBottomRowData"
              @grid-ready="onPacksCountbandGridReady"
              @first-data-rendered="onPacksCountbandFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onPacksCountbandModelUpdated"
              @rowSelected="onPacksCountbandRowSelected"
              @cellContextMenu="onPacksCountbandRowRightClicked"
            ></ag-grid-vue>
          </el-col>
          <el-col :span="18" class="grid-container-modalinfopacks">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="packsQuantityColumnDefs"
              :rowData="packsQuantity"
              :defaultColDef="defaultColDef"
              :gridOptions="packsQuantityGridOptions"
              :modules="agGridModules"
              :getRowStyle="getRowStyle"
              :pinnedBottomRowData="packsQuantityPinnedBottomRowData"
              @grid-ready="onPacksQuantityGridReady"
              @first-data-rendered="onPacksQuantityFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onPacksQuantityModelUpdated"
              @rowSelected="onPacksQuantityRowSelected"
              @cellContextMenu="onPacksQuantityRowRightClicked"
            ></ag-grid-vue>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <div v-if="infoPackReceiptsBtnContainer">
              <el-button
                type="primary"
                size="small"
                @click="receiptsModalSubmit"
                :disabled="infoPackReceiptsBtnDisabled"
                v-shortkey="{ F9: ['f9'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F9</span
                >{{ $t("common.buttons.posting") }}</el-button
              >
            </div>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button type="plain" size="small" @click="receiptsModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.close") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  nameFirme,
  kindName,
  userName,
  statusName,
  reasonName,
  sortSum,
  formatSum
} from "@/helpers/reference";
import { mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $, gt } from "moneysafe";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { dialogWidth } from "@/mixins/dialogWidth";
import { checkAccess } from "@/helpers/access";

export default {
  name: "packsreceipts",
  components: {
    AgGridVue
  },
  mixins: [pickerOptions, dialogWidth],
  data() {
    const validateReasonStorn = (rule, value, callback) => {
      if (this.stornForm.typeStornId === 0 && !value) {
        callback(new Error(this.$t("common.validations.reasonStorn.message")));
      } else {
        callback();
      }
    };
    const validateDateRange = (rule, value, callback) => {
      if (this.filterForm.dateEnabled && !value) {
        callback(new Error(this.$t("common.validations.dateRange.message")));
      } else {
        callback();
      }
    };
    const validateOrganizationCode = (rule, value, callback) => {
      if (this.filterForm.organizationEnabled && !value) {
        callback(
          new Error(this.$t("common.validations.confirmeCodefirme.message"))
        );
      } else {
        callback();
      }
    };
    const validatePaymentCode = (rule, value, callback) => {
      if (this.filterForm.paymentEnabled && !value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateSumRange = (rule, value, callback) => {
      if (
        this.filterForm.sumEnabled &&
        gt($(this.filterForm.sumBegin), $(this.filterForm.sumEnd))
      ) {
        callback(new Error(this.$t("common.validations.sumRange.message")));
      } else {
        callback();
      }
    };
    const validateStatusCode = (rule, value, callback) => {
      if (this.filterForm.statusEnabled && !value) {
        callback(new Error(this.$t("common.validations.statusCode.message")));
      } else {
        callback();
      }
    };
    const validateOperatorCode = (rule, value, callback) => {
      if (this.filterForm.operatorEnabled && !value) {
        callback(new Error(this.$t("common.validations.userPayment.message")));
      } else {
        callback();
      }
    };
    const validateRcount = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.rcount.message")));
      } else {
        callback();
      }
    };
    const validatePayment = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateSummaPack = (rule, value, callback) => {
      const kind = this.params.gkindpay.data.filter(
        item => item.kindpay === this.editForm.kindpay
      );
      const negsum = kind.length > 0 ? kind[0].negsum : "";
      if (value < 0 && negsum === "0") {
        callback(new Error(this.$t("common.validations.summaPack.aboveZero")));
      } else if (value === 0 && this.params.goptions.allowzeropays !== "yes") {
        callback(
          new Error(this.$t("common.validations.summaPack.notEqualZero"))
        );
      } else {
        callback();
      }
    };
    const validateUserPayment = (rule, value, callback) => {
      if (this.visibleOperator && !value) {
        callback(new Error(this.$t("common.validations.userPayment.message")));
      } else {
        callback();
      }
    };
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      controlPacksGridOptions: null,
      controlPacksGridApi: null,
      controlPacksColumnApi: null,
      packsCountbandGridOptions: null,
      packsCountbandGridApi: null,
      packsCountbandColumnApi: null,
      packsQuantityGridOptions: null,
      packsQuantityGridApi: null,
      packsQuantityColumnApi: null,
      getRowStyle: null,
      controlPacksPinnedBottomRowData: null,
      packsCountbandPinnedBottomRowData: null,
      packsQuantityPinnedBottomRowData: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      controlPacksColumnDefs: [
        {
          headerName: this.$t("controlpacks.controlPacksColumn.headers.packs"),
          headerTooltip: this.$t(
            "controlpacks.controlPacksColumn.headers.packs"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.npackSystem"),
              headerTooltip: this.$t("common.gridColumns.npackSystem"),
              field: "npack",
              tooltipField: "npack",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.statusname"),
              headerTooltip: this.$t("common.gridColumns.statusname"),
              field: "statusname",
              tooltipField: "statusname"
            },
            {
              headerName: this.$t("common.gridColumns.namefirmeSender"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSender"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              sort: "asc",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summa",
              tooltipField: "summa",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.countband"),
              headerTooltip: this.$t("common.gridColumns.countband"),
              field: "countband",
              tooltipField: "countband",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.quantity"),
              headerTooltip: this.$t("common.gridColumns.quantity"),
              field: "quantity",
              tooltipField: "quantity",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.reasonname"),
              headerTooltip: this.$t("common.gridColumns.reasonname"),
              field: "reasonname",
              tooltipField: "reasonname"
            },
            {
              headerName: this.$t("common.gridColumns.username"),
              headerTooltip: this.$t("common.gridColumns.username"),
              field: "username",
              tooltipField: "username"
            }
          ]
        },
        {
          headerName: this.$t(
            "controlpacks.controlPacksColumn.headers.payment"
          ),
          headerTooltip: this.$t(
            "controlpacks.controlPacksColumn.headers.payment"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.namefirmeSenderPay"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSenderPay"),
              field: "paycodenamefirme",
              tooltipField: "paycodenamefirme"
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "paydate",
              tooltipField: "paydate",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "paykindname",
              tooltipField: "paykindname"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "paysumma",
              tooltipField: "paysumma",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            }
          ]
        }
      ],
      packsCountbandColumnDefs: [
        {
          headerName: this.$t(
            "controlpacks.packsCountbandColumn.headers.packsCountband"
          ),
          headerTooltip: this.$t(
            "controlpacks.packsCountbandColumn.headers.packsCountband"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.nband"),
              headerTooltip: this.$t("common.gridColumns.nband"),
              field: "nband",
              tooltipField: "nband",
              sort: "asc",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.countpay"),
              headerTooltip: this.$t("common.gridColumns.countpay"),
              field: "countpay",
              tooltipField: "countpay",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summband",
              tooltipField: "summband",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            }
          ]
        }
      ],
      packsQuantityColumnDefs: [
        {
          headerName: this.$t(
            "controlpacks.packsQuantityColumn.headers.packsQuantity"
          ),
          headerTooltip: this.$t(
            "controlpacks.packsQuantityColumn.headers.packsQuantity"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeNumber"),
              headerTooltip: this.$t("common.gridColumns.abcodeNumber"),
              field: "abcode",
              tooltipField: "abcode"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.nameplat"),
              headerTooltip: this.$t("common.gridColumns.nameplat"),
              field: "nameplat",
              tooltipField: "nameplat"
            },
            {
              headerName: this.$t("common.gridColumns.fio"),
              headerTooltip: this.$t("common.gridColumns.fio"),
              field: "fio",
              tooltipField: "fio"
            },
            {
              headerName: this.$t("common.gridColumns.adress"),
              headerTooltip: this.$t("common.gridColumns.adress"),
              field: "adress",
              tooltipField: "adress"
            }
          ]
        }
      ],
      filterType: "primary",
      filterModal: false,
      filterForm: {
        dateEnabled: null,
        dateRange: [],
        organizationEnabled: null,
        organizationCode: null,
        paymentEnabled: null,
        paymentCode: null,
        sumEnabled: null,
        sumBegin: 0,
        sumEnd: 0,
        statusEnabled: null,
        statusCode: null,
        operatorEnabled: null,
        operatorCode: null
      },
      filterRules: {
        dateRange: [{ validator: validateDateRange, trigger: "blur" }],
        organizationCode: [
          { validator: validateOrganizationCode, trigger: "blur" }
        ],
        paymentCode: [{ validator: validatePaymentCode, trigger: "blur" }],
        sumRange: [{ validator: validateSumRange, trigger: "blur" }],
        statusCode: [{ validator: validateStatusCode, trigger: "blur" }],
        operatorCode: [{ validator: validateOperatorCode, trigger: "blur" }]
      },
      filterStatusOptions: [
        {
          value: "0",
          label: this.$t("controlpacks.filterStatusOptions.undeployed")
        },
        {
          value: "2",
          label: this.$t("controlpacks.filterStatusOptions.deployed")
        },
        {
          value: "4",
          label: this.$t("controlpacks.filterStatusOptions.invalid")
        }
      ],
      editModal: false,
      statusModify: null,
      titleEditModal: null,
      labelQuantity: null,
      labelCountband: null,
      visibleSumprof: true,
      visibleOperator: false,
      editFieldDisabled: false,
      statusCheck: null,
      lastRow: null,
      editForm: {
        isimport: null,
        packnumber: null,
        datebank: null,
        mfo: null,
        codefirmeCode: null,
        codefirme: null,
        senders: [],
        accountSender: null,
        kindpayCode: null,
        kindpay: null,
        payments: [],
        quantity: null,
        countband: null,
        summa: 0,
        sumprof: 0,
        paysheetid: null,
        datebeginfact: null,
        npack: null,
        useridCode: null,
        userid: null
      },
      editRules: {
        accountSender: [
          { required: true, validator: validateRcount, trigger: "blur" }
        ],
        kindpay: [
          { required: true, validator: validatePayment, trigger: "blur" }
        ],
        quantity: [
          {
            required: true,
            message: this.$t("common.validations.quantity.required"),
            trigger: "blur"
          }
        ],
        countband: [
          {
            required: true,
            message: this.$t("common.validations.countband.required"),
            trigger: "blur"
          }
        ],
        summa: [
          { required: true, validator: validateSummaPack, trigger: "blur" }
        ],
        userid: [
          { required: true, validator: validateUserPayment, trigger: "blur" }
        ]
      },
      receiptsModal: false,
      receiptsForm: {
        summa: null,
        datebank: null,
        quantity: null,
        countband: null,
        reasonname: null
      },
      money: {
        decimal: ".",
        thousands: " ",
        precision: 2
      },
      stornModal: false,
      stornForm: {
        typeStornId: 0,
        reasonStornIdCode: null,
        reasonStornId: null,
        currentReasonStorn: null
      },
      stornRules: {
        reasonStornId: [{ validator: validateReasonStorn, trigger: "blur" }]
      },
      stornReasons: [],
      stornDialogModal: false,
      statusAfterQuestModal: false,
      statusModifyPacksReceiptsModal: false,
      stornSubmitModal: false,
      editBtnDisabled: true,
      deleteBtnDisabled: true,
      receiptsBtnDisabled: true,
      currentPacksRowSelected: null,
      currentPacksCountbandRowSelected: null,
      currentPacksQuantityRowSelected: null,
      infoPackReceiptsBtnDisabled: true,
      infoPackReceiptsBtnContainer: null
    };
  },
  computed: {
    ...mapGetters([
      "controlPacksFilter",
      "controlPacks",
      "statusPrepareChangeCheck",
      "statusAfterQuestion",
      "statusStornPack",
      "statusModifyPacksReceipts",
      "packsCountband",
      "packsQuantity",
      "statusInfoPack",
      "initPage",
      "loading",
      "params"
    ]),
    organizationName: function() {
      const code = this.controlPacksFilter.organization.code;
      return code ? nameFirme(this.params.gfirme.data, code) : "";
    },
    paymentName: function() {
      const code = this.controlPacksFilter.payment.code;
      return code ? kindName(this.params.gkindpay.data, code) : "";
    },
    operatorName: function() {
      const code = this.controlPacksFilter.operator.code;
      return code ? userName(this.params.gusers.data, code) : "";
    },
    statusPackName: function() {
      const code = this.controlPacksFilter.status.code;
      return code ? statusName(code) : "";
    },
    checkAllModal: function() {
      return (
        !this.filterModal &&
        !this.editModal &&
        !this.receiptsModal &&
        !this.stornModal &&
        !this.stornDialogModal &&
        !this.statusAfterQuestModal &&
        !this.statusModifyPacksReceiptsModal &&
        !this.stornSubmitModal
      );
    }
  },
  watch: {
    statusPrepareChangeCheck: function(value) {
      if (value) {
        if (value.questiongroup === 1) {
          this.stornDialogModal = true;
          this.$confirm(
            value.questiontext,
            this.$t("controlpacks.statusPrepareChangeCheck.title"),
            {
              confirmButtonText: this.$t("common.buttons.confirmYes"),
              cancelButtonText: this.$t("common.buttons.confirmNo"),
              cancelButtonClass: "cancel-button",
              type: "warning"
            }
          )
            .then(() => {
              this.stornDialogModal = false;
              const { npack, kindpay } = this.currentPacksRowSelected;

              this.$store.commit("clearStatusAfterQuestion");
              this.$store.dispatch("afterQuestion", { npack, kindpay });
            })
            .catch(() => {
              this.stornDialogModal = false;
            });
        } else if (value.questiongroup === 2) {
          this.stornReasons = [];
          this.statusPrepareChangeCheck.reason.forEach(item =>
            this.stornReasons.push(item)
          );
          this.currentReasonStorn = this.statusPrepareChangeCheck.codereason;
          this.stornModal = true;
        }
      }
    },
    statusAfterQuestion: function(value) {
      if (value) {
        this.statusAfterQuestModal = true;
        this.$confirm(
          value.questiontext,
          this.$t("controlpacks.statusAfterQuestion.title"),
          {
            confirmButtonText: this.$t("common.buttons.confirmYes"),
            cancelButtonText: this.$t("common.buttons.confirmNo"),
            cancelButtonClass: "cancel-button",
            type: "warning"
          }
        )
          .then(() => {
            this.statusAfterQuestModal = false;
            const { npack } = this.currentPacksRowSelected;

            this.$store.commit("clearStatusStornPack");
            this.$store.dispatch("stornPack", { npack });
          })
          .catch(() => {
            this.statusAfterQuestModal = false;
          });
      }
    },
    statusStornPack: function(value) {
      if (value) {
        this.lastRow = null;
        this.getControlPacks();
      }
    },
    statusModifyPacksReceipts: async function(value) {
      if (value && value.hasOwnProperty("question")) {
        this.statusCheck = null;

        this.statusModifyPacksReceiptsModal = true;
        for (const item of value.question) {
          try {
            await this.$confirm(
              item,
              this.$t("controlpacks.statusModifyPacksReceipts.title"),
              {
                confirmButtonText: this.$t("common.buttons.confirmYes"),
                cancelButtonText: this.$t("common.buttons.confirmNo"),
                cancelButtonClass: "cancel-button",
                type: "warning"
              }
            );
            this.statusCheck = true;
          } catch {
            this.statusCheck = false;
          }
          if (!this.statusCheck) break;
        }
        this.statusModifyPacksReceiptsModal = false;

        if (this.statusCheck && this.statusModify === "edit") {
          this.confirmEdit("1");
        }
      } else if (value && value.hasOwnProperty("rows")) {
        this.editModal = false;

        this.lastRow = value.hasOwnProperty("lastrow")
          ? value.lastrow.toString()
          : "";
        this.getControlPacks();
      }
    },
    "editForm.datebank": function(date) {
      if (date) {
        const currentDate = parseInt(this.$moment(date, "DD.MM.YYYY").unix());
        this.editForm.senders = this.params.gfirme.data.filter(
          item =>
            currentDate >=
              parseInt(this.$moment(item.datebegin, "DD.MM.YYYY").unix()) &&
            currentDate <=
              parseInt(this.$moment(item.dateend, "DD.MM.YYYY").unix()) &&
            ["1", "2", "4"].includes(item.codegroup)
        );
      } else {
        this.editForm.mfo = "";
        this.editForm.codefirme = null;
        this.editForm.senders = [];
        this.editForm.accountSender = "";
      }
    },
    "editForm.codefirme": function(codefirme) {
      this.editForm.codefirmeCode = +codefirme || null;
      if (codefirme) {
        const gfirme = this.params.gfirme.data.filter(
          item => item.codefirme === codefirme
        );
        this.editForm.mfo = gfirme.length > 0 ? gfirme[0].mfo : "";
        this.editForm.accountSender = gfirme.length > 0 ? gfirme[0].rcount : "";
      } else {
        this.editForm.mfo = "";
        this.editForm.accountSender = "";
      }
    },
    "editForm.kindpay": function(kindpay) {
      this.editForm.kindpayCode = +kindpay || null;
      if (kindpay && ["88", "91", "99"].includes(kindpay)) {
        this.visibleSumprof = false;
        this.visibleOperator = true;
        this.labelQuantity = this.$t(
          "controlpacks.edit.form.quantity.numberSubs"
        );
        this.labelCountband = this.$t(
          "controlpacks.edit.form.countband.numberSheets"
        );
        switch (kindpay) {
          case "88":
            this.titleEditModal = this.$t(
              "controlpacks.edit.modal.compensationDisability"
            );
            break;
          case "91":
            this.titleEditModal = this.$t(
              "controlpacks.edit.modal.socialSupplementInfo"
            );
            break;
          case "99":
            this.titleEditModal = this.$t(
              "controlpacks.edit.modal.subsidyInfo"
            );
            break;
        }
      } else {
        this.visibleSumprof = true;
        this.visibleOperator = false;
        this.labelQuantity = this.$t(
          "controlpacks.edit.form.quantity.numberReceipts"
        );
        this.labelCountband = this.$t(
          "controlpacks.edit.form.countband.numberCountband"
        );
        this.titleEditModal = this.$t("controlpacks.edit.modal.infoPack");
      }
    },
    statusInfoPack: function(npack) {
      if (npack) {
        const message = `${this.$t(
          "controlpacks.statusInfoPack.pack"
        )} №${npack} ${this.$t("controlpacks.statusInfoPack.wasDeliver")}`;
        this.$alert(message, this.$t("controlpacks.statusInfoPack.title"), {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          callback: () => {
            this.receiptsModal = false;
            this.getControlPacks();
          }
        });
      }
    },
    "stornForm.reasonStornId": function(value) {
      this.stornForm.reasonStornIdCode = +value || null;
    },
    "editForm.userid": function(value) {
      this.editForm.useridCode = +value || null;
    }
  },
  beforeCreate() {
    if (!checkAccess(77)) {
      this.$router.push("/");
    }
  },
  created() {
    document.title = this.$t("controlpacks.title");
    this.getParams({
      account: "1",
      gfirme: "1",
      gkindpay: "1",
      gusers: "1",
      codepay: "1",
      codereason: "1",
      guserspackedit: "1"
    });

    window.addEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.controlPacksGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText,
      rowClassRules: {
        "ag-status-error": params => params.data.status == "4"
      }
    };

    this.packsCountbandGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.packsQuantityGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.getRowStyle = params => {
      if (params.node.rowPinned) return { "font-weight": "bold" };
    };

    let filter;
    const savedFilter = this.$localStorage.get("wb-controlpacks-filter");
    if (savedFilter) {
      filter = JSON.parse(savedFilter);
      if (isNaN(Number(filter.sum.sumBegin))) filter.sum.sumBegin = "0.00";
      if (isNaN(Number(filter.sum.sumEnd))) filter.sum.sumEnd = "0.00";
    } else {
      const dateBegin = this.$moment()
        .subtract(1, "months")
        .format("DD.MM.YYYY");
      const dateEnd = this.$moment()
        .add(1, "months")
        .format("DD.MM.YYYY");
      filter = {
        period: {
          enabled: true,
          dateBegin: dateBegin,
          dateEnd: dateEnd
        },
        organization: {
          enabled: false,
          code: null
        },
        payment: {
          enabled: false,
          code: null
        },
        sum: {
          enabled: false,
          sumBegin: null,
          sumEnd: null
        },
        status: {
          enabled: false,
          code: null
        },
        operator: {
          enabled: false,
          code: null
        }
      };
      this.$localStorage.set("wb-controlpacks-filter", JSON.stringify(filter));
    }
    this.$store.commit("setControlPacksFilter", filter);
  },
  beforeDestroy() {
    this.$store.commit("setControlPacksFilter", {
      period: {
        enabled: false,
        dateBegin: "",
        dateEnd: ""
      },
      organization: {
        enabled: false,
        code: null
      },
      payment: {
        enabled: false,
        code: null
      },
      sum: {
        enabled: false,
        sumBegin: null,
        sumEnd: null
      },
      status: {
        enabled: false,
        code: null
      },
      operator: {
        enabled: false,
        code: null
      }
    });
    this.$store.commit("setParams", null);
    this.$store.commit("clearControlPacks");
    this.$store.commit("clearStatusPrepareChangeCheck");
    this.$store.commit("clearStatusAfterQuestion");
    this.$store.commit("clearStatusStornPack");
    this.$store.commit("clearStatusModifyPacksReceipts");
    this.$store.commit("clearPacksCountband");
    this.$store.commit("clearPacksQuantity");
    this.$store.commit("clearStatusLinkPack");
    this.$store.commit("clearStatusInfoPack");

    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions(["getParams"]),
    onGridSizeChanged(params) {
      // params.api.sizeColumnsToFit();
    },
    onEditBtn() {
      this.statusModify = "edit";
      this.editModal = true;
    },
    onReceiptsBtn() {
      this.receiptsModal = true;
    },
    onDeleteBtn() {
      const {
        npack,
        kindpay,
        status,
        datebeginfact
      } = this.currentPacksRowSelected;

      this.$store.commit("clearStatusPrepareChangeCheck");
      this.$store.dispatch("prepareChangeCheck", {
        npack,
        kindpay,
        status,
        datebeginfact
      });
    },
    onChangeMfo(value) {
      if (value) {
        const gfirme = this.params.gfirme.data.filter(
          item => item.mfo === value
        );
        if (gfirme.length > 0 && this.editForm.datebank) {
          this.editForm.codefirme = gfirme[0].codefirme;
        }
      } else {
        this.editForm.codefirme = null;
      }
    },
    onControlPacksGridReady(params) {
      this.controlPacksGridApi = params.api;
      this.controlPacksColumnApi = params.columnApi;

      this.getControlPacks();
    },
    onControlPacksFirstDataRendered(event) {
      setGridView("wb-controlpacks-grid-controlpacks", event, "full");
    },
    onControlPacksRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-controlpacks-grid-controlpacks"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onControlPacksModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.filterType = rowCount >= 100 ? "danger" : "primary";
      this.editBtnDisabled = this.deleteBtnDisabled = this.receiptsBtnDisabled =
        rowCount === 0 ? true : false;

      params.api.forEachNode(node => {
        if (this.lastRow) {
          node.setSelected(node.data.npack === this.lastRow);
        } else {
          node.rowIndex ? 0 : node.setSelected(true);
        }
      });

      let pinnedRowSumma = 0;
      let pinnedRowCountband = 0;
      let pinnedRowQuantity = 0;

      for (let i = 0; i < rowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        pinnedRowSumma = $(pinnedRowSumma)
          .add($(rowNode.data.summa))
          .toNumber();
        pinnedRowCountband = $(pinnedRowCountband)
          .add($(rowNode.data.countband))
          .toNumber();
        pinnedRowQuantity = $(pinnedRowQuantity)
          .add($(rowNode.data.quantity))
          .toNumber();
      }
      pinnedRowSumma = formatSum($(pinnedRowSumma).toFixed());

      try {
        this.controlPacksPinnedBottomRowData = [
          {
            npack: "",
            status: "",
            codefirm: "",
            datebank: "",
            kindpay: "",
            summa: pinnedRowSumma,
            countband: pinnedRowCountband,
            quantity: pinnedRowQuantity,
            codereason: "",
            userid: "",
            paycodefirme: "",
            paydate: "",
            paykindpay: "",
            paysumma: ""
          }
        ];
      } catch {
        this.controlPacksPinnedBottomRowData = [
          {
            npack: "",
            status: "",
            codefirm: "",
            datebank: "",
            kindpay: "",
            summa: "0.00",
            countband: "0",
            quantity: "0",
            codereason: "",
            userid: "",
            paycodefirme: "",
            paydate: "",
            paykindpay: "",
            paysumma: ""
          }
        ];
      }
    },
    onControlPacksRowSelected(params) {
      if (params.node.selected) {
        params.api.ensureIndexVisible(params.node.rowIndex);

        this.currentPacksRowSelected = params.node.data;
        const { kindpay, status } = this.currentPacksRowSelected;

        this.editBtnDisabled =
          ["6", "9", "91", "99", "88"].includes(kindpay) || status == "4"
            ? false
            : true;

        this.deleteBtnDisabled =
          status !== "2" && !["97", "98"].includes(kindpay) ? false : true;

        this.receiptsBtnDisabled = status !== "2" ? false : true;
      }
    },
    onPacksCountbandGridReady(params) {
      this.packsCountbandGridApi = params.api;
      this.packsCountbandColumnApi = params.columnApi;
    },
    onPacksCountbandFirstDataRendered(event) {
      setGridView("wb-assignoperators-grid-packscountband", event, "optimal");
    },
    onPacksCountbandRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-assignoperators-grid-packscountband"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPacksCountbandModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );

      let pinnedRowCountpay = 0;
      let pinnedRowSummband = 0;

      for (let i = 0; i < rowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        pinnedRowCountpay = $(pinnedRowCountpay)
          .add($(rowNode.data.countpay))
          .toNumber();
        pinnedRowSummband = $(pinnedRowSummband)
          .add($(rowNode.data.summband))
          .toNumber();
      }
      const pinnedRowCountpayEq = pinnedRowCountpay.toString();
      const pinnedRowSummbandEq = $(pinnedRowSummband).toFixed();
      const receiptsFormSumma = $(this.receiptsForm.summa).toFixed();
      pinnedRowSummband = formatSum(pinnedRowSummbandEq);

      try {
        this.packsCountbandPinnedBottomRowData = [
          {
            nband: "",
            countpay: pinnedRowCountpay,
            summband: pinnedRowSummband
          }
        ];

        if (rowCount === 0) {
          this.infoPackReceiptsBtnDisabled = true;
        } else {
          this.infoPackReceiptsBtnDisabled =
            this.receiptsForm.quantity === pinnedRowCountpayEq &&
            receiptsFormSumma === pinnedRowSummbandEq
              ? false
              : true;
        }
      } catch {
        this.packsCountbandPinnedBottomRowData = [
          {
            nband: "",
            countpay: "0",
            summband: "0.00"
          }
        ];

        this.infoPackReceiptsBtnDisabled = true;
      }
    },
    onPacksCountbandRowSelected(params) {
      if (params.node.selected) {
        this.currentPacksCountbandRowSelected = params.node.data;

        const { npack } = this.currentPacksRowSelected;
        const { nband } = this.currentPacksCountbandRowSelected;

        if (this.packsQuantityGridOptions.api) {
          this.packsQuantityGridOptions.api.setRowData([]);
          this.packsQuantityGridOptions.api.showLoadingOverlay();
        }
        this.$store.dispatch("getPacksQuantity", { npack, nband });
      }
    },
    onPacksQuantityGridReady(params) {
      this.packsQuantityGridApi = params.api;
      this.packsQuantityColumnApi = params.columnApi;
    },
    onPacksQuantityFirstDataRendered(event) {
      setGridView("wb-assignoperators-grid-packsquantity", event, "optimal");
    },
    onPacksQuantityRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-assignoperators-grid-packsquantity"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPacksQuantityModelUpdated(params) {
      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );

      const pinnedRowCount = params.api.getDisplayedRowCount();
      let pinnedRowSummpay = 0;
      for (let i = 0; i < pinnedRowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        pinnedRowSummpay = $(pinnedRowSummpay)
          .add($(rowNode.data.summpay))
          .toNumber();
      }
      pinnedRowSummpay = formatSum($(pinnedRowSummpay).toFixed());

      try {
        this.packsQuantityPinnedBottomRowData = [
          {
            abcode: pinnedRowCount,
            summpay: pinnedRowSummpay,
            dateclient: "",
            codeplat: "",
            fio: "",
            adress: ""
          }
        ];
      } catch {
        this.packsQuantityPinnedBottomRowData = [
          {
            abcode: "0",
            summpay: "0.00",
            dateclient: "",
            codeplat: "",
            fio: "",
            adress: ""
          }
        ];
      }
    },
    onPacksQuantityRowSelected(params) {
      if (params.node.selected) {
        this.currentPacksQuantityRowSelected = params.node.data;
      }
    },
    getControlPacks() {
      if (this.controlPacksGridOptions.api) {
        this.controlPacksGridOptions.api.setRowData([]);
        this.controlPacksGridOptions.api.showLoadingOverlay();
      }

      this.$store.dispatch("getControlPacks");
    },
    confirmEdit(confirm) {
      const {
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa,
        sumprof,
        paysheetid,
        quantity,
        npack,
        isimport,
        userid,
        datebeginfact
      } = this.editForm;

      const behavior = "6";
      const checkSumprof = ["88", "91", "99"].includes(kindpay) ? 0 : sumprof;

      this.$store.commit("clearStatusModifyPacksReceipts");
      this.$store.dispatch("packsReceiptsEdit", {
        behavior,
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa: summa ? $(summa).toFixed() : "",
        sumprof: checkSumprof ? $(checkSumprof).toFixed() : "",
        paysheetid,
        quantity,
        npack,
        isimport,
        userid,
        datebeginfact,
        confirm
      });
    },
    filterModalShow() {
      const dateBegin = this.controlPacksFilter.period.dateBegin;
      const dateEnd = this.controlPacksFilter.period.dateEnd;
      this.filterForm = {
        dateEnabled: this.controlPacksFilter.period.enabled,
        dateRange: [dateBegin, dateEnd],
        organizationEnabled: this.controlPacksFilter.organization.enabled,
        organizationCode: this.controlPacksFilter.organization.code,
        paymentEnabled: this.controlPacksFilter.payment.enabled,
        paymentCode: this.controlPacksFilter.payment.code,
        sumEnabled: this.controlPacksFilter.sum.enabled,
        sumBegin: $(this.controlPacksFilter.sum.sumBegin).toNumber(),
        sumEnd: $(this.controlPacksFilter.sum.sumEnd).toNumber(),
        statusEnabled: this.controlPacksFilter.status.enabled,
        statusCode: this.controlPacksFilter.status.code,
        operatorEnabled: this.controlPacksFilter.operator.enabled,
        operatorCode: this.controlPacksFilter.operator.code
      };
    },
    filterModalHide() {
      this.filterForm = {
        dateEnabled: null,
        dateRange: [],
        organizationEnabled: null,
        organizationCode: null,
        paymentEnabled: null,
        paymentCode: null,
        sumEnabled: null,
        sumBegin: 0,
        sumEnd: 0,
        statusEnabled: null,
        statusCode: null,
        operatorEnabled: null,
        operatorCode: null
      };
      this.$refs.filterForm.resetFields();
    },
    filterModalSubmit() {
      this.$refs.filterForm.validate(valid => {
        if (valid) {
          const filter = {
            period: {
              enabled: this.filterForm.dateEnabled,
              dateBegin: this.filterForm.dateRange[0],
              dateEnd: this.filterForm.dateRange[1]
            },
            organization: {
              enabled: this.filterForm.organizationEnabled,
              code: this.filterForm.organizationCode
            },
            payment: {
              enabled: this.filterForm.paymentEnabled,
              code: this.filterForm.paymentCode
            },
            sum: {
              enabled: this.filterForm.sumEnabled,
              sumBegin: this.filterForm.sumBegin
                ? $(this.filterForm.sumBegin).toFixed()
                : "0.00",
              sumEnd: this.filterForm.sumEnd
                ? $(this.filterForm.sumEnd).toFixed()
                : "0.00"
            },
            status: {
              enabled: this.filterForm.statusEnabled,
              code: this.filterForm.statusCode
            },
            operator: {
              enabled: this.filterForm.operatorEnabled,
              code: this.filterForm.operatorCode
            }
          };
          this.$localStorage.set(
            "wb-controlpacks-filter",
            JSON.stringify(filter)
          );
          this.$store.commit("setControlPacksFilter", filter);
          this.filterModal = false;

          this.lastRow = null;
          this.getControlPacks();
        }
      });
    },
    stornModalShow() {
      this.stornForm.typeStornId = 0;
      this.stornForm.reasonStornId = this.currentReasonStorn;
    },
    stornModalHide() {
      (this.stornForm = {
        typeStornId: 0,
        reasonStornIdCode: null,
        reasonStornId: null,
        currentReasonStorn: null
      }),
        this.$refs.stornForm.resetFields();
    },
    stornModalSubmit() {
      this.$refs.stornForm.validate(valid => {
        if (valid) {
          this.stornModal = false;

          const codereason = this.stornForm.reasonStornId;
          const reason = this.stornReasons.filter(
            item => item.codereason === codereason
          );
          const codereasonName = reason.length > 0 ? reason[0].namereason : "";

          const typeStornId = this.stornForm.typeStornId;
          const stornMessage =
            typeStornId === 0
              ? `${this.$t(
                  "controlpacks.stornModalSubmit.returnReason"
                )} - ${codereasonName}. ${this.$t(
                  "controlpacks.stornModalSubmit.continue"
                )}?`
              : `${this.$t(
                  "controlpacks.stornModalSubmit.allReceiptsDeleted"
                )}. ${this.$t("controlpacks.stornModalSubmit.continue")}?`;

          this.stornSubmitModal = true;
          this.$confirm(
            stornMessage,
            this.$t("controlpacks.stornModalSubmit.confirm.title"),
            {
              confirmButtonText: this.$t("common.buttons.confirmYes"),
              cancelButtonText: this.$t("common.buttons.confirmNo"),
              cancelButtonClass: "cancel-button",
              type: "warning"
            }
          )
            .then(() => {
              this.stornSubmitModal = false;
              const { npack, datebeginfact } = this.currentPacksRowSelected;
              this.$store.commit("clearStatusStornPack");

              typeStornId === 0
                ? this.$store.dispatch("stornPackManual", {
                    npack,
                    codereason,
                    datebeginfact
                  })
                : this.$store.dispatch("stornPack", { npack });
            })
            .catch(() => {
              this.stornSubmitModal = false;
            });
        }
      });
    },
    editModalShow() {
      this.visibleSumprof = true;
      this.visibleOperator = false;
      this.titleEditModal = this.$t("controlpacks.edit.modal.infoPack");
      this.labelQuantity = this.$t(
        "controlpacks.edit.form.quantity.numberReceipts"
      );
      this.labelCountband = this.$t(
        "controlpacks.edit.form.countband.numberCountband"
      );

      const {
        isimport,
        packnumber,
        datebank,
        codefirme,
        kindpay,
        quantity,
        countband,
        summa,
        sumprof,
        paysheetid,
        datebeginfact,
        npack,
        userid
      } = this.currentPacksRowSelected;

      this.editForm = {
        isimport,
        packnumber,
        datebank,
        quantity,
        mfo: "",
        codefirme,
        senders: [],
        accountSender: "",
        kindpay,
        countband,
        summa: $(summa).toNumber(),
        sumprof: $(sumprof).toNumber(),
        paysheetid,
        datebeginfact,
        npack,
        userid
      };

      this.editForm.payments = this.params.gkindpay.data.filter(
        item =>
          !["50", "90", "97", "98", "100"].includes(item.kindpay) &&
          item.used === "1"
      );
      this.editFieldDisabled =
        this.editForm.isimport === "1" || this.editForm.status === "2"
          ? true
          : false;
    },
    editModalHide() {
      this.statusModify = null;
      this.editForm = {
        isimport: null,
        packnumber: null,
        datebank: null,
        mfo: null,
        codefirmeCode: null,
        codefirme: null,
        senders: [],
        accountSender: null,
        kindpayCode: null,
        kindpay: null,
        payments: [],
        quantity: null,
        countband: null,
        summa: 0,
        sumprof: 0,
        paysheetid: null,
        datebeginfact: null,
        npack: null,
        useridCode: null,
        userid: null
      };
      this.$refs.editForm.resetFields();
    },
    editModalSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.confirmEdit("");
        }
      });
    },
    receiptsModalShow() {
      const {
        kindpay,
        npack,
        paysheetid,
        summa,
        datebank,
        quantity,
        countband,
        codereason
      } = this.currentPacksRowSelected;

      this.receiptsForm = {
        summa: $(summa).toNumber(),
        datebank,
        quantity,
        countband,
        reasonname: reasonName(this.params.codereason.data, codereason)
      };

      this.infoPackReceiptsBtnContainer =
        paysheetid || ["41", "99", "100"].includes(kindpay) ? true : false;

      if (this.packsCountbandGridOptions.api) {
        this.packsCountbandGridOptions.api.setRowData([]);
        this.packsCountbandGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPacksCountband", { npack });
    },
    receiptsModalHide() {
      this.receiptsForm = {
        summa: null,
        datebank: null,
        quantity: null,
        countband: null,
        reasonname: null
      };
      this.infoPackReceiptsBtnContainer = null;

      this.$store.commit("clearPacksCountband");
      this.$store.commit("clearPacksQuantity");
    },
    receiptsModalSubmit() {
      let { npack } = this.currentPacksRowSelected;
      npack = npack.trim();

      this.$store.commit("clearStatusInfoPack");
      this.$store.dispatch("receiptsInfoPack", { npack });
    },
    onChangeReasonStornIdCode(event) {
      const value = event.target.value;
      const reasons = this.stornReasons.filter(
        item => item.codereason === value
      );
      if (reasons.length > 0) {
        this.stornForm.reasonStornId = value;
      } else {
        this.stornForm.reasonStornId = null;
        this.stornForm.reasonStornIdCode = null;
      }
    },
    onChangeUseridCode(event) {
      const value = event.target.value;
      const users = this.params.guserspackedit.data.filter(
        item => item.userid === value
      );
      if (users.length > 0) {
        this.editForm.userid = value;
      } else {
        this.editForm.userid = null;
        this.editForm.useridCode = null;
      }
    },
    onChangeKindpayCode(event) {
      const value = event.target.value;
      const kindpays = this.editForm.payments.filter(
        item => item.kindpay === value
      );
      if (kindpays.length > 0) {
        this.editForm.kindpay = value;
      } else {
        this.editForm.kindpay = null;
        this.editForm.kindpayCode = null;
      }
    },
    onChangeCodefirmeCode(event) {
      const value = event.target.value;
      const codefirmes = this.editForm.senders.filter(
        item => item.codefirme === value
      );
      if (codefirmes.length > 0) {
        this.editForm.codefirme = value;
      } else {
        this.editForm.codefirme = null;
        this.editForm.codefirmeCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        case "Enter":
        case "F4":
        case "Star":
          // edit: Enter, F4, Star
          if (this.checkAllModal && !this.editBtnDisabled) {
            this.onEditBtn();
          }
          break;
        case "F7":
          // filterModal
          if (this.checkAllModal) {
            this.filterModal = true;
          }
          break;
        case "F9":
          // receipts
          if (this.checkAllModal && !this.receiptsBtnDisabled) {
            this.onReceiptsBtn();
          }
          // receipts: receiptsModal
          else if (
            this.receiptsModal &&
            this.infoPackReceiptsBtnContainer &&
            !this.infoPackReceiptsBtnDisabled
          ) {
            this.receiptsModalSubmit();
          }
          break;
        case "F10":
          // submit: filterModalSubmit
          if (this.filterModal) {
            this.filterModalSubmit();
          }
          // submit: editModalSubmit
          else if (this.editModal) {
            this.editModalSubmit();
          }
          // submit: stornModalSubmit
          else if (this.stornModal) {
            this.stornModalSubmit();
          }
          break;
        case "Del":
        case "Minus":
          // delete: Del, Minus
          if (this.checkAllModal && !this.deleteBtnDisabled) {
            this.onDeleteBtn();
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ag-header-icon .ag-header-cell-sorted-asc {
  color: green !important;
}

.radio-vertical-block {
  display: block;
}
.moneydisable {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:hover {
    border-color: #e4e7ed;
  }
}

.grid-container-full {
  margin-top: 10px;
  height: calc(100vh - 175px);
  overflow-y: auto;
}

.grid-container-modal {
  height: calc(100vh - 250px);
  overflow-y: auto;
}

.grid-container-modalinfopacks {
  margin-top: 10px;
  height: calc(50vh);
  overflow-y: auto;
}
</style>
